<template>
  <div>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="no-gutters" style="margin-top: 10px">
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-select solo v-model="closedTradTime" :items="dateOptions" item-text="label" item-value="value"
            label="Select date" append-icon="mdi-chevron-down" class="custom-select"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12">
          <v-card class="pa-3 rounded-0 elevation-0 chart-tab" :color="$vuetify.theme.dark ? '#172233' : '#E0EAF2'">
            <v-sheet v-if="singleAccountProfitLossSummary" class="pb-3"
              :color="$vuetify.theme.dark ? '#1A2A3E ' : '#E8F1F8'">
              <apexChart width="100%" height="338px" type="bar" :options="chartOptions" :series="series"
                class="liveTradeChart">
              </apexChart>
            </v-sheet>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CHARTS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      baseOptions: {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false,
          },
          background: "#131c29",
        },
        xaxis: {
          labels: {
            style: {
              colors: "#708AA7",
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: "#708AA7",
            },
            formatter: (value) => {
              if (value >= 1000) return `${(value / 1000).toFixed(1)}k`;
              return value.toFixed(1);
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "60%",
            colors: {
              ranges: [
                {
                  from: 0,
                  to: Infinity,
                  color: "#14D7B2",
                },
                {
                  from: -Infinity,
                  to: 0,
                  color: "#647E98",
                },
              ],
            },
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          show: true,
          showForSingleSeries: true,
          customLegendItems: ["Profit", "Loss"],
          labels: {
            colors: ["#14D7B2", "#647E98"],
            useSeriesColors: false,
          },
          markers: {
            fillColors: ["#14D7B2", "#647E98"],
            radius: 8,
          },
        },
      },
      time: "last-week",
      closedTradTime: "last-week",
      dateOptions: [
        { label: "Last Week", value: "last-week" },
        { label: "Last Month", value: "last-month" },
        { label: "Last Year", value: "last-year" }
      ]
    };
  },

  computed: {
    chartOptions() {
      return {
        ...this.baseOptions,
        tooltip: {
          enabled: true,
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            const value = parseFloat(series[seriesIndex][dataPointIndex]);
            if (value === 0) {
              return "";
            }
            return (
              '<div class="arrow_box">' +
              "<span>" +
              value.toFixed(2) +
              "</span>" +
              "</div>"
            );
          },
        },
        xaxis: {
          ...this.baseOptions.xaxis,
          categories: this.singleAccountProfitLossSummary?.labels || [],
        },
        yaxis: {
          ...this.baseOptions.yaxis,
          min: 0,
          max: undefined, // Let ApexCharts determine the max value
        },
      };
    },

    series() {
      const data = this.singleAccountProfitLossSummary?.data || [];

      const seriesData = [
        {
          name: "Amount",
          data: data.map((item) => {
            let value = parseFloat(item.totalProfit);

            return {
              x: item.Time.split("-").reverse().join("."),
              y: value === 0 ? 0.001 : Math.abs(value),
              fillColor:
                value === 0 ? "#1C2C40" : value > 0 ? "#14D7B2" : "#647E98",
            };
          }),
        },
      ];

      return seriesData;
    },

    ...mapState("charts", ["singleAccountProfitLossSummary"]),
  },

  methods: {
    ...mapActions("charts", [CHARTS__ACTIONS.SINGLEACCOUNTPROFITLOSSSUMMARY]),

    async fetchChartData(time, id) {
      const data = { time, id };
      await this[CHARTS__ACTIONS.SINGLEACCOUNTPROFITLOSSSUMMARY](data);
    },
  },

  watch: {
    async closedTradTime(newTime, oldTime) {
      if (newTime !== oldTime) {
        try {
          await this.fetchChartData(newTime, this.$route.query.id);
        } catch (error) {
          console.error(error);
        }
      }
    },
  },

  async mounted() {
    const data = { time: this.time, id: this.$route.query.id };
    await this[CHARTS__ACTIONS.SINGLEACCOUNTPROFITLOSSSUMMARY](data);
  },
};
</script>
